module.exports = "images/miscellaneous_favorite.1168237e447b360036f14f04fb5d470c.png";